import React, { FC } from "react";
import { Dropdown as RsuiteDropdown } from "rsuite";
import { Option } from "@shared/interfaces";

import "./index.scss";

export interface DropdownProps {
  options: Option[];
  handleClick: (value: string) => void;
  title: string;
}

export const Dropdown: FC<DropdownProps> = ({ options, handleClick, title }) => {
  return (
    <RsuiteDropdown title={title} placement="bottomEnd">
      {options.map((o) => (
        <RsuiteDropdown.Item onClick={() => handleClick(o.value)} key={o.value} value={o.value}>
          {o.label}
        </RsuiteDropdown.Item>
      ))}
    </RsuiteDropdown>
  );
};

export default Dropdown;
